import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {FacilitesTable} from './table/FacilitiesTable'
import {FacilityEditModal} from './facilitie-edit-modal/FacilitieEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {FacilityListHeader} from './header/FacilitieListHeader'
import { ToastContainer } from 'react-toastify'

const FacilitiesList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ToastContainer />
        <FacilityListHeader />
        <FacilitesTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <FacilityEditModal />}
    </>
  )
}

const FacilitiesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <FacilitiesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {FacilitiesListWrapper}
